module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper long-contents"
  }, [_c('app-header'), _c('div', {
    staticClass: "container moral-start bg03 long-contents"
  }, [_vm._m(0), _c('div', {
    staticClass: "row moral-start__sec01"
  }, [_vm._m(1), _vm._m(2), _c('div', {
    staticClass: "moral-start__sec01__inner"
  }, [_vm._m(3), _c('button', {
    staticClass: "btn01 moral-start__sec01__inner__btn",
    on: {
      "click": _vm.goMoralCheck
    }
  }, [_c('span', [_vm._v("今月のチェックをはじめる")])]), _c('p', {
    staticClass: "moral-start__sec01__inner__link"
  }, [_c('router-link', {
    attrs: {
      "to": "/moral_guidance"
    }
  }, [_c('span', [_vm._v("「モラル確認の手引き」を確認する")])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "moralcheck-title"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_01.png"),
      "alt": "今月も要チェックだニャン！毎月のモラルチェック！"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "heading_01 mb25"
  }, [_vm._v("毎月のモラルチェック"), _c('br'), _vm._v("って"), _c('br'), _vm._v("なんだニャン？")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_01 mb10 moral-start__sec01__body"
  }, [_c('p', [_vm._v("会社として、営業を続けるために"), _c('br'), _vm._v("守らないといけない法律上のルールなどを、"), _c('br'), _vm._v("みんなに毎月必ず確認してもらおう!"), _c('br'), _vm._v("という趣旨の取り組みです。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "moral-start__sec01__inner__txt"
  }, [_vm._v("今月は、本社の役員と店舗長が"), _c('br'), _vm._v("内容をチェックするニャン！")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c30b644!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/moral-start.pug
// module id = 1372
// module chunks = 1